import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Formik } from 'formik';
import dynamicfunction from '../../../utils/dynamicfunction';
import { convertIntoArray, getContentKeyAccToLang } from '../../../utils/utils';
import { Checkbox, ErrorText, RadioButton, RowView, Text } from '../../CorporateForm/components';
import Button from '../../../components/Button';
import { fontSizes } from '../../../constants/constants';
import { useNavigate } from 'react-router';
import CustomInput from '../../../components/CustomInput';
import { logoutUser } from '../../../store/actions/authActions';
import { individual_international_tax_self_certification_validation_schema } from '../../../validations_schemas/individual_international_tax_self_certification_schema';
import {
  getIndContactInformationData,
  getIndTaxDeclarationData,
  postIndTaxDeclaration,
  saveIndKycTaxDeclaration,
} from '../../../store/actions/individualAction';
import icons from '../../../constants/icons';
import { Dropdown } from '../../../components';
import { VI } from 'country-flag-icons/react/3x2';
import ViewItems from '../../../components/ViewItems';
import CustomCheckbox from '../../../components/CustomCheckbox';
import { bank_soure_validation_schema } from '../../../validations_schemas/bank_information_schema';

const TaxDeclaration = ({ onDone }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isArabic, TextWeight } = dynamicfunction();
  const { individualContent, language } = useSelector((state) => state.content);

  const { ind_post_loading, ind_tax_declaration_data, ind_tax_declaration_dropdown_data, ind_contact_information_dropdown_data } = useSelector(
    (state) => state.individual,
  );

  const { client_application_id, is_kyc } = useSelector((state) => state.constant);

  const getContent = (key) => {
    return getContentKeyAccToLang(individualContent?.tax_declaration?.data?.attributes, key, isArabic);
  };

  const myArray = convertIntoArray(ind_tax_declaration_dropdown_data);
  const countryArray = convertIntoArray(ind_contact_information_dropdown_data);

  useEffect(() => {
    getData();
  }, [language]);

  const getData = async () => {
    await dispatch(getIndContactInformationData(client_application_id));
    await dispatch(getIndTaxDeclarationData(client_application_id));
  }

  const onSubmit = (values) => {
    const api_data = {
      // inputs: {
      ...ind_tax_declaration_data,
      areYouAUSPerson: values?.areYouAUSPerson === '1' ? true : false,
      socialSecurityNumber1: values?.socialSecurityNumber1,
      individualTaxpayerIdentificationNumber1: values?.individualTaxpayerIdentificationNumber1,
      aTaxpayerIdentificationNumber1: values?.aTaxpayerIdentificationNumber1,
      citizenshipCountries: values?.citizenshipCountries?.map(item => item?.code) ?? null,

      doYouHaveAnImmigrantVisaOrInACountryOtherThanSaudiArabia:
        values?.doYouHaveAnImmigrantVisaOrInACountryOtherThanSaudiArabia === '1' ? true : false,
      taxImmigrantJurisdiction_Section2_Show: values?.visaResident?.[1]?.taxImmigrantJurisdiction_Section_Show,
      taxImmigrantJurisdiction_Section3_Show: values?.visaResident?.[2]?.taxImmigrantJurisdiction_Section_Show,
      visaJurisdictionCountryName1: values?.visaResident?.[0]?.country,
      visaJurisdictionCountryName2: values?.visaResident?.[1]?.country,
      visaJurisdictionCountryName3: values?.visaResident?.[2]?.country,
      pleaseIndicateTheStatusOfEachPermanentResidencyId1: values?.visaResident?.[0]?.residencyStatus?.id ?? null,
      pleaseIndicateTheStatusOfEachPermanentResidencyId2: values?.visaResident?.[1]?.residencyStatus?.id ?? null,
      pleaseIndicateTheStatusOfEachPermanentResidencyId3: values?.visaResident?.[2]?.residencyStatus?.id ?? null,

      areYouATaxResidentOfAnyCountryOrCountriesOutsideOfSaudiArabia:
        values?.areYouATaxResidentOfAnyCountryOrCountriesOutsideOfSaudiArabia === '1' ? true : false,

      taxResidentJurisdiction_Section2_Show: values?.taxResident?.[1]?.taxResidentJurisdiction_Section_Show,
      taxResidentJurisdiction_Section3_Show: values?.taxResident?.[2]?.taxResidentJurisdiction_Section_Show,

      taxJurisdictionCountry1: values?.taxResident?.[0]?.country?.name ?? '',
      taxJurisdictionCountry2: values?.taxResident?.[1]?.country?.name ?? '',
      taxJurisdictionCountry3: values?.taxResident?.[2]?.country?.name ?? '',
      taxpayerIdentificationNumber1: values?.taxResident?.[0]?.tin ?? '',
      taxpayerIdentificationNumber2: values?.taxResident?.[1]?.tin ?? '',
      taxpayerIdentificationNumber3: values?.taxResident?.[2]?.tin ?? '',
      tinJurisdictionStatusId1: values?.taxResident?.[0]?.tinJurisdictionStatus?.[0]?.valueId ?? null,
      tinJurisdictionStatusId2: values?.taxResident?.[1]?.tinJurisdictionStatus?.[0]?.valueId ?? null,
      tinJurisdictionStatusId3: values?.taxResident?.[2]?.tinJurisdictionStatus?.[0]?.valueId ?? null,
      taxTINOther1: values?.taxResident?.[0]?.tinOther ?? '',
      taxTINOther2: values?.taxResident?.[1]?.tinOther ?? '',
      taxTINOther3: values?.taxResident?.[2]?.tinOther ?? '',
      iUnderstandAndAgreeToTheDeclarationAndSignature:
        values?.iUnderstandAndAgreeToTheDeclarationAndSignature ?? false,
    };

    dispatch(
      is_kyc
        ? saveIndKycTaxDeclaration(api_data, (res) => {
          values?.isSaveExist ? navigate('/funds/available-funds') : onDone();
        })
        : postIndTaxDeclaration(api_data, (res) => {
          values?.isSaveExist ? dispatch(logoutUser()) : onDone();
        }),
    );
  };

  const optionsYesOrNO = [
    { id: 1, name: getContent('yes') },
    { id: 0, name: getContent('no') },
  ];

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={{
          areYouAUSPerson: ind_tax_declaration_data?.areYouAUSPerson === true ? '1' : '0',
          socialSecurityNumber1: ind_tax_declaration_data?.socialSecurityNumber1 ?? '',
          individualTaxpayerIdentificationNumber1: ind_tax_declaration_data?.individualTaxpayerIdentificationNumber1 ?? '',
          aTaxpayerIdentificationNumber1: ind_tax_declaration_data?.aTaxpayerIdentificationNumber1 ?? '',
          citizenshipCountries: Array.isArray(ind_tax_declaration_data?.citizenshipCountries)
            ? ind_tax_declaration_data.citizenshipCountries
              .map((code) => {
                const country = countryArray?.countryListWithCode?.find(
                  (item) => item?.name?.countryCode === code
                );

                return country
                  ? {
                    id: country?.id,
                    name: country?.name?.displayName,
                    code: country?.name?.countryCode,
                  }
                  : null;
              })
              .filter(Boolean)
            : (() => {
              const country = countryArray?.countryListWithCode?.find(
                (item) =>
                  item?.name?.countryCode === ind_tax_declaration_data?.citizenshipCountries
              );

              return country
                ? {
                  id: country?.id,
                  name: country?.name?.displayName,
                  code: country?.name?.countryCode,
                }
                : null;
            })(),
          doYouHaveAnImmigrantVisaOrInACountryOtherThanSaudiArabia:
            ind_tax_declaration_data?.doYouHaveAnImmigrantVisaOrInACountryOtherThanSaudiArabia === true
              ? '1' : '0',

          areYouATaxResidentOfAnyCountryOrCountriesOutsideOfSaudiArabia:
            ind_tax_declaration_data?.areYouATaxResidentOfAnyCountryOrCountriesOutsideOfSaudiArabia === true
              ? '1' : '0',
          visaResident: [
            {
              taxImmigrantJurisdiction_Section_Show: true,
              country: ind_tax_declaration_data?.visaJurisdictionCountryName1 ?? '',
              residencyStatus: myArray?.residencyStatusList?.find(
                (item) => item?.id === String(ind_tax_declaration_data?.pleaseIndicateTheStatusOfEachPermanentResidencyId1),
              ) || null,
            },
            {
              taxImmigrantJurisdiction_Section_Show: ind_tax_declaration_data?.taxImmigrantJurisdiction_Section2_Show ?? false,
              country: ind_tax_declaration_data?.visaJurisdictionCountryName2 ?? '',
              residencyStatus: myArray?.residencyStatusList?.find(
                (item) => item?.id === String(ind_tax_declaration_data?.pleaseIndicateTheStatusOfEachPermanentResidencyId2),
              ) || null,
            },
            {
              taxImmigrantJurisdiction_Section_Show: ind_tax_declaration_data?.taxImmigrantJurisdiction_Section3_Show ?? false,
              country: ind_tax_declaration_data?.visaJurisdictionCountryName3 ?? '',
              residencyStatus: myArray?.residencyStatusList?.find(
                (item) => item?.id === String(ind_tax_declaration_data?.pleaseIndicateTheStatusOfEachPermanentResidencyId3),
              ) || null,
            },
          ],

          taxResident: [
            {
              country: countryArray?.countryList?.find((item) => item?.name === ind_tax_declaration_data?.taxJurisdictionCountry1) ?? null,
              tin: ind_tax_declaration_data?.taxpayerIdentificationNumber1 ?? null,
              taxResidentJurisdiction_Section_Show: true,
              tinJurisdictionStatus:
                (myArray?.tinJurisdictionStatusList || [])
                  .filter((item) =>
                    Number(ind_tax_declaration_data?.tinJurisdictionStatusId1) === Number(item?.id)
                  )
                  .map((item) => ({
                    typeOfInvestmentId: 0,
                    valueId: item?.id,
                    otherTypeOfInvestment: item?.name,
                  })) ?? [],
              tinOther: ind_tax_declaration_data?.taxTINOther1 ?? '',
            },
            {
              country: countryArray?.countryList?.find((item) => item?.name === ind_tax_declaration_data?.taxJurisdictionCountry2) ?? null,
              tin: ind_tax_declaration_data?.taxpayerIdentificationNumber2 ?? null,
              taxResidentJurisdiction_Section_Show: ind_tax_declaration_data?.taxResidentJurisdiction_Section2_Show ?? false,
              tinJurisdictionStatus:
                (myArray?.tinJurisdictionStatusList || [])
                  .filter((item) =>
                    Number(ind_tax_declaration_data?.tinJurisdictionStatusId2) === Number(item?.id)
                  )
                  .map((item) => ({
                    typeOfInvestmentId: 0,
                    valueId: item?.id,
                    otherTypeOfInvestment: item?.name,
                  })) ?? [],
              tinOther: ind_tax_declaration_data?.taxTINOther2 ?? '',
            },
            {
              country: countryArray?.countryList?.find((item) => item?.name === ind_tax_declaration_data?.taxJurisdictionCountry3) ?? null,
              tin: ind_tax_declaration_data?.taxpayerIdentificationNumber3 ?? null,
              taxResidentJurisdiction_Section_Show: ind_tax_declaration_data?.taxResidentJurisdiction_Section3_Show ?? false,
              tinJurisdictionStatus:
                (myArray?.tinJurisdictionStatusList || [])
                  .filter((item) =>
                    Number(ind_tax_declaration_data?.tinJurisdictionStatusId3) === Number(item?.id)
                  )
                  .map((item) => ({
                    typeOfInvestmentId: 0,
                    valueId: item?.id,
                    otherTypeOfInvestment: item?.name,
                  })) ?? [],
              tinOther: ind_tax_declaration_data?.taxTINOther3 ?? '',
            },
          ],
          iUnderstandAndAgreeToTheDeclarationAndSignature:
            ind_tax_declaration_data?.iUnderstandAndAgreeToTheDeclarationAndSignature ?? false,
          isSaveExist: false,
        }}
        onSubmit={(values) => {
          onSubmit(values);
        }}
        validateOnChange={true}
        validateOnBlur={true}
        validationSchema={individual_international_tax_self_certification_validation_schema}
      >
        {({ handleSubmit, setFieldValue, values, resetForm, setFieldError, errors, setFieldTouched, touched, submitCount }) => {

          return (
            <div className=''>
              <RowView className='pt-3 sm:pt-5' isResponsive>
                <div className='w-full'>
                  <RadioButton
                    isRequired
                    label={getContent('is_us_person')}
                    value={values?.areYouAUSPerson}
                    onChange={(e) => {
                      setFieldValue('areYouAUSPerson', e);
                      setFieldTouched('areYouAUSPerson', false);
                    }}
                    options={optionsYesOrNO}
                  />
                  <ErrorText text={getContent(touched?.areYouAUSPerson ? errors?.areYouAUSPerson : '')} />
                </div>
              </RowView>
              {values?.areYouAUSPerson?.toString() === '1' && (
                <div>
                  <div className='pt-3 sm:pt-5'>
                    <Text
                      isRequired
                      text={getContent('usa_tax_resident')}
                      size={fontSizes.h22}
                      isTruncate={false}
                      weight={TextWeight.semiBold}
                      className={'block'}
                    />
                  </div>
                  <div className='pt-3 sm:pt-5'>
                    <Text
                      isRequired
                      text={getContent('please_provide_one')}
                      size={fontSizes.h18}
                      isTruncate={false}
                      weight={TextWeight.medium}
                      className={'block'}
                    />
                  </div>
                  <RowView className='gap-7 pt-3 sm:pt-5' isResponsive>
                    <CustomInput
                      label={getContent('ssn_number')}
                      labelDivClass={'sm:h-6 md:h-12 xl:h-9 2xl:h-6'}
                      isRounded
                      isRequired
                      maxLength={30}
                      placeholder={getContent('enter_number')}
                      value={values?.socialSecurityNumber1}
                      onChange={(e) => {
                        setFieldValue('socialSecurityNumber1', e.target.value);
                        setFieldTouched('socialSecurityNumber1', true, false);
                      }}
                      errorMessage={
                        getContent(touched?.socialSecurityNumber1 ? errors?.socialSecurityNumber1 : '')
                      }
                    />
                    <CustomInput
                      label={getContent('itin_number')}
                      labelDivClass={'h-9 sm:h-6 md:h-12 xl:h-9 2xl:h-6'}
                      isRounded
                      isRequired
                      maxLength={30}
                      placeholder={getContent('enter_number')}
                      value={values?.individualTaxpayerIdentificationNumber1}
                      onChange={(e) => {
                        setFieldValue('individualTaxpayerIdentificationNumber1', e.target.value);
                        setFieldTouched('individualTaxpayerIdentificationNumber1', true, false);
                      }}
                      errorMessage={
                        getContent(touched?.individualTaxpayerIdentificationNumber1 ? errors?.individualTaxpayerIdentificationNumber1 : '')
                      }
                    />
                    <CustomInput
                      label={getContent('atin_number')}
                      labelDivClass={'h-9 sm:h-6 md:h-12 xl:h-9 2xl:h-6'}
                      isRounded
                      isRequired
                      maxLength={30}
                      placeholder={getContent('enter_number')}
                      value={values?.aTaxpayerIdentificationNumber1}
                      onChange={(e) => {
                        setFieldValue('aTaxpayerIdentificationNumber1', e.target.value);
                        setFieldTouched('aTaxpayerIdentificationNumber1', true, false);
                      }}
                      errorMessage={
                        getContent(touched?.aTaxpayerIdentificationNumber1 ? errors?.aTaxpayerIdentificationNumber1 : '')
                      }
                    />
                  </RowView>
                  <ViewItems className={'pt-3 sm:pt-5'}>
                    <Dropdown
                      label={getContent('citizenship_country')}
                      isSearch
                      isMulti
                      options={countryArray?.countryListWithCode?.map((item) => ({
                        id: item?.id,
                        name: item?.name?.displayName,
                        code: item?.name?.countryCode,
                      })) ?? []}
                      selectedValue={values?.citizenshipCountries}
                      valueKey={`name`}
                      onSelect={(val) => {
                        setFieldValue('citizenshipCountries', val);
                      }}
                      errorMessage={
                        getContent(
                          touched?.citizenshipCountries
                            ? errors?.citizenshipCountries
                            : ''
                        )
                      }
                    />
                  </ViewItems>
                </div>
              )}
              <RowView className='pt-3 sm:pt-5' isResponsive>
                <div className='w-full'>
                  <RadioButton
                    isRequired
                    label={getContent('is_immigration_visa')}
                    value={values?.doYouHaveAnImmigrantVisaOrInACountryOtherThanSaudiArabia}
                    onChange={(e) => {
                      setFieldValue('doYouHaveAnImmigrantVisaOrInACountryOtherThanSaudiArabia', e);
                      setFieldTouched('doYouHaveAnImmigrantVisaOrInACountryOtherThanSaudiArabia', false);
                    }}
                    options={optionsYesOrNO}
                  />
                  <ErrorText
                    text={getContent(
                      touched?.doYouHaveAnImmigrantVisaOrInACountryOtherThanSaudiArabia
                        ? errors?.doYouHaveAnImmigrantVisaOrInACountryOtherThanSaudiArabia
                        : '',
                    )}
                  />
                </div>
              </RowView>
              {values?.doYouHaveAnImmigrantVisaOrInACountryOtherThanSaudiArabia?.toString() === '1' && (
                <div>
                  <RowView className='gap-3 pt-3 sm:pt-5 justify-between mb-4'>
                    <Text
                      text={getContent('visa_residency_information')}
                      color='text-black'
                      weight={TextWeight.semiBold}
                      isTruncate={false}
                      size={fontSizes.h22}
                    />

                    {(!values?.visaResident?.[1]?.taxImmigrantJurisdiction_Section_Show ||
                      !values?.visaResident?.[2]?.taxImmigrantJurisdiction_Section_Show) && (
                        <div className='flex justify-end gap-3'>
                          <Button
                            text={getContent('additional_field')}
                            color={'text-white hover:text-primary'}
                            bgColor='bg-primary hover:bg-transparent hover:border-primary'
                            className={'border border-transparent w-44 px-0 text-center'}
                            onClick={() => {
                              let array = [...values?.visaResident];

                              if (values?.visaResident?.[1]?.taxImmigrantJurisdiction_Section_Show) {
                                array[2].taxImmigrantJurisdiction_Section_Show = true;
                              }

                              if (!values?.visaResident?.[1]?.taxImmigrantJurisdiction_Section_Show) {
                                array[1].taxImmigrantJurisdiction_Section_Show = true;
                              }

                              setFieldValue('visaResident', array);
                            }}
                          />
                        </div>
                      )}
                  </RowView>
                </div>)}
              {values?.doYouHaveAnImmigrantVisaOrInACountryOtherThanSaudiArabia?.toString() === '1' && (
                values?.visaResident?.map((item, index) => {
                  return (
                    item?.taxImmigrantJurisdiction_Section_Show && (
                      <>
                        {index > 0 && (
                          <div className={`flex ${isArabic ? "justify-start" : "justify-end"}`}>
                            <Button
                              text={getContent('delete')}
                              icon={icons.delete_white_icon}
                              bgColor='bg-primary'
                              className={'mt-4 w-44 px-0 text-center'}
                              onClick={() => {
                                const updated = [...values.visaResident];
                                updated[index].taxImmigrantJurisdiction_Section_Show = false;
                                updated[index].country = '';
                                updated[index].residencyStatus = '';
                                setFieldValue('visaResident', updated);
                              }}
                            />
                          </div>
                        )}
                        <RowView key={index} className='gap-7 pt-3 sm:pt-5 w-full' isResponsive>
                          <CustomInput
                            label={`${getContent('country_jurisdiction')} ${index + 1}`}
                            labelDivClass={'sm:h-6 md:h-9 xl:h-9 2xl:h-6'}
                            isRounded
                            maxLength={50}
                            placeholder={getContent('please_specify')}
                            value={item?.country}
                            onChange={(e) => {
                              const updated = [...values.visaResident];
                              updated[index].country = e.target.value;
                              setFieldValue('visaResident', updated);
                            }}
                            errorMessage={
                              getContent(touched?.visaResident?.[index]?.country ? errors?.visaResident?.[index]?.country : '')
                            }
                          />
                          <Dropdown
                            label={`${getContent('specify_permanent_residency')} ${index + 1}`}
                            labelDivClass={'sm:h-6 md:h-9 xl:h-9 2xl:h-6'}
                            isSearch
                            placeholder={getContent('please_specify')}
                            options={myArray?.residencyStatusList}
                            selectedValue={item?.residencyStatus}
                            valueKey={'name'}
                            onSelect={(val) => {
                              const updated = [...values.visaResident];
                              updated[index].residencyStatus = val;
                              setFieldValue('visaResident', updated);
                            }}
                            errorMessage={
                              getContent(touched?.visaResident?.[index]?.residencyStatus ? errors?.visaResident?.[index]?.residencyStatus : '')
                            }
                          />
                          <div className='lg:w-full hidden lg:block'></div>
                        </RowView>
                      </>
                    )
                  );
                }))}

              <RowView className='pt-3 sm:pt-5' isResponsive>
                <div className='w-full'>
                  <RadioButton
                    isRequired
                    label={getContent('is_tax_resident_outside_saudi')}
                    value={values?.areYouATaxResidentOfAnyCountryOrCountriesOutsideOfSaudiArabia}
                    onChange={(e) => {
                      setFieldValue('areYouATaxResidentOfAnyCountryOrCountriesOutsideOfSaudiArabia', e);
                      setFieldTouched('areYouATaxResidentOfAnyCountryOrCountriesOutsideOfSaudiArabia', false);
                    }}
                    options={optionsYesOrNO}
                  />
                  <ErrorText
                    text={getContent(
                      touched?.areYouATaxResidentOfAnyCountryOrCountriesOutsideOfSaudiArabia
                        ? errors?.areYouATaxResidentOfAnyCountryOrCountriesOutsideOfSaudiArabia
                        : '',
                    )}
                  />
                </div>
              </RowView>

              {values?.areYouATaxResidentOfAnyCountryOrCountriesOutsideOfSaudiArabia?.toString() === '1' && (
                (!values?.taxResident?.[1]?.taxResidentJurisdiction_Section_Show ||
                  !values?.taxResident?.[2]?.taxResidentJurisdiction_Section_Show) && (
                  <div className={`flex gap-3 ${isArabic ? "justify-start" : "justify-end"}`}>
                    <Button
                      text={getContent('additional_field')}
                      color={'text-white hover:text-primary'}
                      bgColor='bg-primary hover:bg-transparent hover:border-primary'
                      className={'border border-transparent w-44 px-0 text-center'}
                      onClick={() => {
                        const array = [...values.taxResident];

                        // If second section visible, show third
                        if (array[1].taxResidentJurisdiction_Section_Show) {
                          array[2].taxResidentJurisdiction_Section_Show = true;
                        }

                        // If second section hidden, show second
                        if (!array[1].taxResidentJurisdiction_Section_Show) {
                          array[1].taxResidentJurisdiction_Section_Show = true;
                        }
                        setFieldValue('taxResident', array);
                      }}
                    />
                  </div>
                )
              )}

              {/* <div className='w-full h-0.5 bg-border mt-3 sm:mt-5'></div> */}
              {values?.areYouATaxResidentOfAnyCountryOrCountriesOutsideOfSaudiArabia?.toString() === '1' && (
                values.taxResident?.map((item, index) => {
                  return (
                    item?.taxResidentJurisdiction_Section_Show && (
                      <>
                        {index !== 0 && (
                          <div className={`flex ${isArabic ? "justify-start" : "justify-end"}`}>
                            <Button
                              text={getContent('delete')}
                              icon={icons.delete_white_icon}
                              bgColor='bg-primary'
                              className={'mt-4 w-44 px-0 text-center'}
                              onClick={() => {
                                const updated = [...values.taxResident];
                                updated[index].country = null;
                                updated[index].tin = null;
                                updated[index].taxResidentJurisdiction_Section_Show = false;
                                updated[index].tinJurisdictionStatus = [];
                                updated[index].tinOther = '';
                                setFieldValue('taxResident', updated);
                              }}
                            />
                          </div>
                        )}
                        <RowView key={index} className='gap-7 pt-3 sm:pt-5' isResponsive>
                          <Dropdown
                            label={`${getContent('country_jurisdiction')} ${index + 1}:`}
                            labelDivClass={'sm:h-6 md:h-9 lg:h-9 xl:h-6'}
                            isSearch
                            placeholder={getContent('select_country_jurisdiction')}
                            options={countryArray?.countryList}
                            selectedValue={item?.country}
                            valueKey='name'
                            onSelect={(val) => {
                              const updated = [...values.taxResident];
                              updated[index].country = val;
                              setFieldValue('taxResident', updated);
                            }}
                            errorMessage={
                              submitCount > 0
                                ? getContent(
                                  touched?.taxResident?.[index]?.country
                                    ? errors?.taxResident?.[index]?.country
                                    : ''
                                )
                                : ''
                            }
                          />
                          <CustomInput
                            label={`${getContent('tin_or_functional_equivalent')} ${index + 1}:`}
                            labelDivClass={'sm:h-6 md:h-9 lg:h-9 xl:h-6'}
                            isRounded
                            placeholder={getContent('enter_number')}
                            value={item?.tin}
                            maxLength={30}
                            onChange={(e) => {
                              const updated = [...values.taxResident];
                              updated[index].tin = e.target.value;
                              updated[index].tinJurisdictionStatus = [];
                              setFieldValue('taxResident', updated);
                            }}
                            errorMessage={
                              submitCount > 0
                                ? getContent(
                                  touched?.taxResident?.[index]?.tin
                                    ? errors?.taxResident?.[index]?.tin
                                    : ''
                                )
                                : ''
                            }
                          />
                        </RowView>
                        {!values?.taxResident[index]?.tin &&
                          <div className='pt-3 sm:pt-5'>
                            <Checkbox
                              label={`${getContent('tin_reasons')} ${index + 1}:`}
                              value={item.tinJurisdictionStatus}
                              onChange={(option) => {
                                let updatedArr = [...values.taxResident];
                                let options = [...(updatedArr[index].tinJurisdictionStatus || [])];
                                const exists = options.some((i) => i.valueId === option.id);
                                if (exists) {
                                  updatedArr[index].tinJurisdictionStatus = []
                                } else {
                                  updatedArr[index].tinJurisdictionStatus = [{
                                    typeOfInvestmentId: 0,
                                    valueId: option.id,
                                    otherTypeOfInvestment: option.name,
                                  }];
                                }
                                setFieldValue('taxResident', updatedArr);
                              }}
                              options={myArray?.tinJurisdictionStatusList}
                              isVertical
                            />
                            <ErrorText
                              className='block'
                              text={getContent(
                                touched?.taxResident?.[index]?.tinJurisdictionStatus
                                  ? errors?.taxResident?.[index]?.tinJurisdictionStatus
                                  : ''
                              )}
                            />
                            {item.tinJurisdictionStatus?.some((i) => i.valueId === '797') && (
                              <RowView isResponsive className='pt-2'>
                                <CustomInput
                                  isRounded
                                  isRequired
                                  label={`${getContent('please_specify')} ${index + 1}:`}
                                  placeholder={getContent('please_specify')}
                                  value={item.tinOther}
                                  onChange={(e) => {
                                    const updated = [...values.taxResident];
                                    updated[index].tinOther = e.target.value;
                                    setFieldValue('taxResident', updated);
                                  }}
                                  errorMessage={
                                    getContent(
                                      touched?.taxResident?.[index]?.tinOther
                                        ? errors?.taxResident?.[index]?.tinOther
                                        : ''
                                    )
                                  }
                                />
                              </RowView>
                            )}
                          </div>
                        }
                      </>
                    )
                  );
                }))}
              <RowView className='pt-3 sm:pt-5 w-full'>
                <CustomCheckbox
                  isChecked={values?.iUnderstandAndAgreeToTheDeclarationAndSignature}
                  label={getContent('understand_and_agree')}
                  secondText={getContent('declaration_and_signature')}
                  onClick={() => {
                    setFieldValue('iUnderstandAndAgreeToTheDeclarationAndSignature', !values?.iUnderstandAndAgreeToTheDeclarationAndSignature);
                    setFieldTouched('iUnderstandAndAgreeToTheDeclarationAndSignature', false);
                  }}
                  onPressSecondText={() => {
                    setFieldValue('iUnderstandAndAgreeToTheDeclarationAndSignature', !values?.iUnderstandAndAgreeToTheDeclarationAndSignature);
                    setFieldTouched('iUnderstandAndAgreeToTheDeclarationAndSignature', false);
                  }}
                />
              </RowView>
              <ErrorText
                text={getContent(
                  touched?.iUnderstandAndAgreeToTheDeclarationAndSignature
                    ? errors?.iUnderstandAndAgreeToTheDeclarationAndSignature
                    : ''
                )}
                className='block'
              />
              <RowView className='gap-3 sm:gap-7 pt-3 sm:pt-5'>
                <Button
                  text={getContent('save_proceed')}
                  color={'text-white hover:text-primary '}
                  bgColor='bg-primary hover:bg-transparent hover:border-primary'
                  className={'border border-transparent w-44 px-0 text-center'}
                  loading={ind_post_loading}
                  type={'submit'}
                  isDisabled={ind_post_loading}
                  onClick={() => {
                    setFieldValue('isSaveExist', false);
                    handleSubmit();
                  }}
                />
                <Button
                  text={getContent('save_exit')}
                  color={'text-primary hover:text-white'}
                  bgColor='bg-white hover:bg-primary'
                  className={'border border-primary w-44 px-0 text-center'}
                  isDisabled={ind_post_loading}
                  onClick={() => {
                    setFieldValue('isSaveExist', true);
                    handleSubmit();
                  }}
                />
              </RowView>
            </div>
          );
        }}
      </Formik>
    </>
  );
};

export default TaxDeclaration;
